export default {
  id: "tools",
  name: "Tools",
  shortName: "Tools",
  description: "Short links, QR codes & more",
  icon: "tools",
  color: "#0EA5E9",
  roles: ["super_admin", "admin", "corporate", "franchisee", "marketing_agency"],
  css: "styles/apps/tools.css",
  nav: [
    { id: "qr-code", label: "Link & QR" },
    { id: "campaigns", label: "Campaigns" },
  ],
  defaultView: "qr-code",
};
